// IM-EXT-018-C01 — CNAE do escopo sem dupla contagem: o que foi selecionado, o que é consultado na fonte oficial, o que
// foi consolidado e por quê. A mesma regra (`normalizeCnaeScope`) roda na API; aqui só é mostrada.
import { CNAE_LEVEL_LABEL, type CnaeScopeNormalization } from '@intelimove/contracts';

const REASON: Record<CnaeScopeNormalization['consolidated'][number]['reason'], string> = {
  DUPLICADO: 'mesmo código em mais de uma origem', COBERTO_POR_NIVEL_MAIS_AMPLO: 'já contido em código mais amplo', NIVEL_DA_FONTE: 'nível publicado pela fonte',
};
export function CnaeScope({ n, title = 'Atividades (CNAE) sem dupla contagem' }: { n: CnaeScopeNormalization; title?: string }) {
  if (!n.selected.length) return null;
  return (
    <div className="cnae-scope" role="group" aria-label={title}>
      <h3 className="sz-h3">{title}</h3>
      <dl className="kv small sz-kv">
        <dt>Selecionados</dt><dd>{n.selected.map((x) => `${x.code} (${CNAE_LEVEL_LABEL[x.level]}; ${x.origins.join(', ')})`).join(' · ')}</dd>
        <dt>Consultados na fonte</dt><dd>{n.consulted.map((x) => `${x.key} (${CNAE_LEVEL_LABEL[x.level]})`).join(' · ')} — a fonte oficial publica até {CNAE_LEVEL_LABEL[n.sourceLevel]}</dd>
        <dt>Consolidados</dt><dd>{n.consolidated.length ? <ul className="notes">{n.consolidated.map((c, i) => <li key={`${c.code}-${c.reason}-${i}`}><b>{REASON[c.reason]}</b>: {c.detail}</li>)}</ul> : 'nenhum — cada código conta uma vez'}</dd>
      </dl>
    </div>
  );
}
